import gql from 'graphql-tag';

import { courseCategoryFragment } from '~/shared/graphql-queries/course-categories/index';

export default gql`
  query findOneCourseCategoryQuery($filter: FilterFindOneCourseCategoryInput!) {
    findOneCourseCategoryQuery(filter: $filter) {
      ...CourseCategoryFragment
    }
  }
  ${courseCategoryFragment}
`;
